import NumberFormat from 'react-number-format';

class CalculCas1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prixNetVendeur: '',
            tauxHonoraires: '',
            honorairesAgence: '',
            nouveauPrixNetVendeur: '',
            resultat: '',
            prixPresentation: '',
            isSubmitted: false,
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({prixNetVendeur: event.target.prixNetVendeur});
        this.setState({tauxHonoraires: event.target.tauxHonoraires});
        this.setState({resultat: null});
    }

    refreshPage() {
        window.location.reload();
    }

    handleSubmit(event) {
        console.log('CalculCas1 : handleSubmit ');
        let tauxHonoraires = event.target.tauxHonoraires.value.replace(',', '.');
        this.setState({prixNetVendeur: event.target.prixNetVendeur.value});
        this.setState({tauxHonoraires: tauxHonoraires});
        this.setState({isSubmitted: true})
        event.preventDefault();

        let prixNetVendeur = event.target.prixNetVendeur.value;
        let resultat = prixNetVendeur * (1 + tauxHonoraires / 100);
        let prixPresentation = Math.ceil(resultat/1000)*1000;
        if (prixPresentation < resultat) {
            prixPresentation += 1000;
        }
        let honorairesAgence = prixPresentation - prixNetVendeur;
        let nouveauPrixNetVendeur = Math.round(prixPresentation / (1 + tauxHonoraires / 100));

        resultat = Math.round(resultat);

        this.setState({honorairesAgence: honorairesAgence});
        this.setState({nouveauPrixNetVendeur: nouveauPrixNetVendeur});
        this.setState({prixPresentation: prixPresentation});
        this.setState({resultat: resultat});
    }

    render() {
        console.log('CalculCas1 : render ');
        let resultatContent;
        if (this.state.resultat && this.state.tauxHonoraires) {
            console.log('CalculCas1 : render resultat');
            resultatContent = <div style={{border: 'thick double #289dcc',padding: 10, margin: 20}}>
                <h4>Calculs</h4>
                Résultat : <NumberFormat value={this.state.resultat} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix de présentation : <NumberFormat value={this.state.prixPresentation} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC pour l'agence : <NumberFormat value={this.state.honorairesAgence} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <h4>Affichage annonce recommandé</h4>
                Prix de vente HAI : <NumberFormat value={this.state.prixPresentation} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix net vendeur : <NumberFormat value={this.state.nouveauPrixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC charge acquéreur : {this.state.tauxHonoraires} %
                <br/><br/>
                <input autoFocus type="submit" value="Faire un nouveau calcul" onClick={this.refreshPage}/>
            </div>;
        }
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        <span className="calculhonos-label">Prix net vendeur (en €) :</span>
                        &nbsp;<input autoFocus type="text" pattern="[0-9,\.]*" name="prixNetVendeur" value={this.state.prixNetVendeur} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <label>
                        <span className="calculhonos-label">Taux honoraires TTC (en %) :</span>
                        &nbsp;<input type="text" pattern="[0-9,\.]*" name="tauxHonoraires" value={this.state.tauxHonoraires} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <input type="submit" value="Calculer" />
                </form>
                {resultatContent}
            </div>
        );
    }
}

class CalculCas2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prixVenteHAI: '',
            tauxHonoraires: '',
            honorairesAgence: '',
            nouveauPrixNetVendeur: '',
            prixNetVendeur: '',
            resultat: '',
            isSubmitted: false,
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({prixVenteHAI: event.target.prixVenteHAI});
        this.setState({tauxHonoraires: event.target.tauxHonoraires});
        this.setState({prixNetVendeur: null});
    }

    handleSubmit(event) {
        console.log('CalculCas2 : handleSubmit ');
        let tauxHonoraires = event.target.tauxHonoraires.value.replace(',', '.');
        this.setState({prixVenteHAI: event.target.prixVenteHAI.value});
        this.setState({tauxHonoraires: tauxHonoraires});
        this.setState({isSubmitted: true})
        event.preventDefault();

        let prixVenteHAI = event.target.prixVenteHAI.value;
        let prixNetVendeur = Math.round(prixVenteHAI / (1 + tauxHonoraires / 100));
        let honorairesAgence = prixVenteHAI - prixNetVendeur;

        this.setState({honorairesAgence: honorairesAgence});
        this.setState({prixNetVendeur: prixNetVendeur});
    }

    refreshPage() {
        window.location.reload();
    }

    render() {
        console.log('CalculCas2 : render ');
        let resultatContent;
        if (this.state.prixNetVendeur) {
            console.log('CalculCas2 : render resultat');
            resultatContent = <div style={{border: 'thick double #289dcc',padding: 10, margin: 20}}>
                <h4>Calculs</h4>
                Prix de vente HAI : <NumberFormat value={this.state.prixVenteHAI} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix net vendeur : <NumberFormat value={this.state.prixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC charge acquéreur : {this.state.tauxHonoraires} %<br/>
                Honoraires TTC pour l'agence : <NumberFormat value={this.state.honorairesAgence} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <h4>Affichage annonce recommandé</h4>
                Prix de vente HAI : <NumberFormat value={this.state.prixVenteHAI} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix net vendeur : <NumberFormat value={this.state.prixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC charge acquéreur : {this.state.tauxHonoraires} %
                <br/><br/>
                <input autoFocus type="submit" value="Faire un nouveau calcul" onClick={this.refreshPage}/>
            </div>;
        }
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        <span className="calculhonos-label">Prix de vente HAI (en €) :</span>
                        &nbsp;<input autoFocus type="text" pattern="[0-9,\.]*" name="prixVenteHAI" value={this.state.prixVenteHAI} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <label>
                        <span className="calculhonos-label">Taux honoraires TTC (en %) :</span>
                        &nbsp;<input type="text" pattern="[0-9,\.]*" name="tauxHonoraires" value={this.state.tauxHonoraires} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <input type="submit" value="Calculer" />
                </form>
                {resultatContent}
            </div>
        );
    }
}

class CalculCas3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prixSoldeVendeur: '',
            tauxHonoraires: '',
            honorairesAgence: '',
            nouveauPrixNetVendeur: '',
            nouveauPrixSoldeVendeur: '',
            prixNetVendeur: '',
            resultat: '',
            isSubmitted: false,
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({prixSoldeVendeur: event.target.prixSoldeVendeur});
        this.setState({tauxHonoraires: event.target.tauxHonoraires});
        this.setState({nouveauPrixSoldeVendeur: null});
    }

    handleSubmit(event) {
        console.log('CalculCas3 : handleSubmit ');
        let tauxHonoraires = event.target.tauxHonoraires.value.replace(',', '.');
        this.setState({prixSoldeVendeur: event.target.prixSoldeVendeur.value});
        this.setState({tauxHonoraires: tauxHonoraires});
        this.setState({isSubmitted: true})
        event.preventDefault();

        let prixSoldeVendeur = event.target.prixSoldeVendeur.value;

        let resultat = Math.round(prixSoldeVendeur / (1 - tauxHonoraires / 100));
        let prixPresentation = Math.ceil(resultat/1000)*1000;
        let honorairesAgence = Math.round(prixPresentation * tauxHonoraires / 100);
        let nouveauPrixSoldeVendeur = prixPresentation - honorairesAgence;

        this.setState({honorairesAgence: honorairesAgence});
        this.setState({prixPresentation: prixPresentation});
        this.setState({nouveauPrixSoldeVendeur: nouveauPrixSoldeVendeur});
        this.setState({resultat: resultat});
    }

    refreshPage() {
        window.location.reload();
    }

    render() {
        console.log('CalculCas3 : render ');
        let resultatContent;
        if (this.state.nouveauPrixSoldeVendeur) {
            console.log('CalculCas3 : render resultat');
            resultatContent = <div style={{border: 'thick double #289dcc',padding: 10, margin: 20}}>
                <h4>Calculs</h4>
                Résultat : <NumberFormat value={this.state.resultat} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix de présentation : <NumberFormat value={this.state.prixPresentation} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC pour l'agence : <NumberFormat value={this.state.honorairesAgence} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Solde vendeur : <NumberFormat value={this.state.nouveauPrixSoldeVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <h4>Affichage annonce recommandé</h4>
                Prix de présentation : <NumberFormat value={this.state.prixPresentation} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <span style={{fontSize: '80%'}}>Honoraires charge vendeur</span><br/>
                <br/><br/>
                <input autoFocus type="submit" value="Faire un nouveau calcul" onClick={this.refreshPage}/>
            </div>;
        }
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        <span className="calculhonos-label">Prix solde vendeur (en €) :</span>
                        &nbsp;<input autoFocus type="text" pattern="[0-9,\.]*" name="prixSoldeVendeur" value={this.state.prixVenteHAI} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <label>
                        <span className="calculhonos-label">Taux honoraires TTC (en %) :</span>
                        &nbsp;<input type="text" pattern="[0-9,\.]*" name="tauxHonoraires" value={this.state.tauxHonoraires} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <input type="submit" value="Calculer" />
                </form>
                {resultatContent}
            </div>
        );
    }
}

class CalculCas4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prixVente: '',
            tauxHonoraires: '',
            honorairesAgence: '',
            nouveauPrixNetVendeur: '',
            prixNetVendeur: '',
            resultat: '',
            isSubmitted: false,
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({prixVente: event.target.prixVente});
        this.setState({tauxHonoraires: event.target.tauxHonoraires});
        this.setState({prixNetVendeur: null});
    }

    handleSubmit(event) {
        console.log('CalculCas4 : handleSubmit ');
        let tauxHonoraires = event.target.tauxHonoraires.value.replace(',', '.');
        this.setState({prixVente: event.target.prixVente.value});
        this.setState({tauxHonoraires: tauxHonoraires});
        this.setState({isSubmitted: true})
        event.preventDefault();

        let prixVente = event.target.prixVente.value;
        let prixNetVendeur = Math.round(prixVente * (1 - tauxHonoraires / 100));
        let honorairesAgence = prixVente - prixNetVendeur;

        this.setState({honorairesAgence: honorairesAgence});
        this.setState({prixNetVendeur: prixNetVendeur});
    }

    refreshPage() {
        window.location.reload();
    }

    render() {
        console.log('CalculCas4 : render ');
        let resultatContent;
        if (this.state.prixNetVendeur) {
            console.log('CalculCas4 : render resultat');
            resultatContent = <div style={{border: 'thick double #289dcc',padding: 10, margin: 20}}>
                <h4>Calculs</h4>
                Prix de vente : <NumberFormat value={this.state.prixVente} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix honoraires déduits pour vendeur : <NumberFormat value={this.state.prixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC charge acquéreur : {this.state.tauxHonoraires} %<br/>
                Honoraires TTC pour l'agence : <NumberFormat value={this.state.honorairesAgence} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <h4>Affichage annonce recommandé</h4>
                Prix net vendeur : <NumberFormat value={this.state.prixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC charge acquéreur : {this.state.tauxHonoraires} %<br/>
                Honoraires TTC pour l'agence : <NumberFormat value={this.state.honorairesAgence} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <input autoFocus type="submit" value="Faire un nouveau calcul" onClick={this.refreshPage}/>
            </div>;
        }
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        <span className="calculhonos-label">Prix de vente (en €) :</span>
                        &nbsp;<input autoFocus type="text" pattern="[0-9,\.]*" name="prixVente" value={this.state.prixVente} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <label>

                        <span className="calculhonos-label">Taux honoraires TTC (en %) :</span>
                        &nbsp;<input type="text" pattern="[0-9,\.]*" name="tauxHonoraires" value={this.state.tauxHonoraires} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <input type="submit" value="Calculer" />
                </form>
                {resultatContent}
            </div>
        );
    }
}

class CalculCas5 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prixSoldeVendeur: '',
            tauxHonoraires: '',
            honoraires: '',
            honorairesAgence: '',
            nouveauPrixNetVendeur: '',
            nouveauPrixSoldeVendeur: '',
            prixNetVendeur: '',
            tauxHonorairesArrondi: '',
            resultat: '',
            isSubmitted: false,
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({prixNetVendeur: event.target.prixNetVendeur});
        this.setState({honoraires: event.target.honoraires});
        this.setState({prixPresentation: event.target.honoraires});
    }

    handleSubmit(event) {
        console.log('CalculCas5 : handleSubmit ');
        this.setState({prixNetVendeur: event.target.prixNetVendeur.value});
        this.setState({honoraires: event.target.honoraires.value});
        this.setState({isSubmitted: true})
        event.preventDefault();

        let prixNetVendeur = event.target.prixNetVendeur.value;
        let honoraires = event.target.honoraires.value;
        let tauxHonoraires = honoraires / prixNetVendeur * 100;
        let tauxHonorairesArrondi = Math.round(100 * (honoraires / prixNetVendeur * 100)) / 100;
        let resultat = prixNetVendeur * (1 + tauxHonoraires / 100);
        let prixPresentation = Math.ceil(resultat/1000)*1000;
        if (prixPresentation < resultat) {
            prixPresentation += 1000;
        }

        this.setState({prixPresentation: prixPresentation});
        this.setState({resultat: resultat});
        this.setState({tauxHonorairesArrondi: tauxHonorairesArrondi});
    }

    refreshPage() {
        window.location.reload();
    }

    render() {
        console.log('CalculCas5 : render ');
        let resultatContent;
        if (this.state.prixPresentation) {
            console.log('CalculCas5 : render resultat');
            resultatContent = <div style={{border: 'thick double #289dcc',padding: 10, margin: 20}}>
                <h4>Calculs</h4>
                Taux honoraires : {this.state.tauxHonorairesArrondi} %<br/>
                Résultat : <NumberFormat value={this.state.resultat} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix de présentation proposé: <NumberFormat value={this.state.prixPresentation} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <h4>Affichage annonce recommandé</h4>
                Prix de vente HAI : <NumberFormat value={this.state.prixPresentation} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix net vendeur : <NumberFormat value={this.state.prixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC charge acquéreur : {this.state.tauxHonorairesArrondi} %
                <br/><br/>
                <input autoFocus type="submit" value="Faire un nouveau calcul" onClick={this.refreshPage}/>
            </div>;
        }
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        <span className="calculhonos-label">Prix net vendeur (en €) :</span>
                        &nbsp;<input autoFocus type="text" pattern="[0-9,\.]*" name="prixNetVendeur" value={this.state.prixNetVendeur} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <label>
                        <span className="calculhonos-label">Honoraires TTC forfaitaires et fixes (en €) :</span>
                        &nbsp;<input type="text" pattern="[0-9,\.]*" name="honoraires" value={this.state.honoraires} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <input type="submit" value="Calculer" />
                </form>
                {resultatContent}
            </div>
        );
    }
}

class CalculCas6 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prixVenteHAI: '',
            tauxHonoraires: '',
            honoraires: '',
            honorairesAgence: '',
            nouveauPrixNetVendeur: '',
            nouveauPrixSoldeVendeur: '',
            prixNetVendeur: '',
            tauxHonorairesArrondi: '',
            resultat: '',
            isSubmitted: false,
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({prixVenteHAI: event.target.prixVenteHAI});
        this.setState({honoraires: event.target.honoraires});
        this.setState({prixNetVendeur: event.target.honoraires});
    }

    handleSubmit(event) {
        console.log('CalculCas6 : handleSubmit ');
        this.setState({prixVenteHAI: event.target.prixVenteHAI.value});
        this.setState({honoraires: event.target.honoraires.value});
        this.setState({isSubmitted: true})
        event.preventDefault();

        let prixVenteHAI = event.target.prixVenteHAI.value;
        let honoraires = event.target.honoraires.value;
        let prixNetVendeur = prixVenteHAI - honoraires;
        let tauxHonoraires = honoraires / prixNetVendeur * 100;
        let tauxHonorairesArrondi = Math.round(100 * (honoraires / prixNetVendeur * 100)) / 100;
        let resultat = Math.round(prixNetVendeur * (1 + tauxHonoraires / 100));
        let prixPresentation = Math.ceil(resultat/1000)*1000;
        if (prixPresentation < resultat) {
            prixPresentation += 1000;
        }

        this.setState({prixPresentation: prixPresentation});
        this.setState({prixNetVendeur: prixNetVendeur});
        this.setState({resultat: resultat});
        this.setState({tauxHonorairesArrondi: tauxHonorairesArrondi});
    }

    refreshPage() {
        window.location.reload();
    }

    render() {
        console.log('CalculCas6 : render ');
        let resultatContent;
        if (this.state.prixNetVendeur) {
            console.log('CalculCas6 : render resultat');
            resultatContent = <div style={{border: 'thick double #289dcc',padding: 10, margin: 20}}>
                <h4>Calculs</h4>
                Prix net vendeur : <NumberFormat value={this.state.prixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Taux honoraires TTC : {this.state.tauxHonorairesArrondi} %<br/>
                Résultat : <NumberFormat value={this.state.resultat} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix de présentation proposé: <NumberFormat value={this.state.prixPresentation}  displayType={'text'} thousandSeparator={' '}/>€ <br/>
                <br/><br/>
                <h4>Affichage annonce recommandé</h4>
                Prix de vente HAI : <NumberFormat value={this.state.prixVenteHAI} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Prix net vendeur : <NumberFormat value={this.state.prixNetVendeur} displayType={'text'} thousandSeparator={' '}/> € <br/>
                Honoraires TTC charge acquéreur : {this.state.tauxHonorairesArrondi} %
                <br/><br/>
                <input autoFocus type="submit" value="Faire un nouveau calcul" onClick={this.refreshPage}/>
            </div>;
        }
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        <span className="calculhonos-label">Prix de vente HAI (en €) :</span>
                        &nbsp;<input autoFocus type="text" pattern="[0-9,\.]*" name="prixVenteHAI" value={this.state.prixVenteHAI} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <label>
                        <span className="calculhonos-label">Honoraires TTC forfaitaires et fixes (en €) :</span>
                        &nbsp;<input type="text" pattern="[0-9,\.]*" name="honoraires" value={this.state.honoraires} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <input type="submit" value="Calculer" />
                </form>
                {resultatContent}
            </div>
        );
    }
}

class CalculCas7 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            prixVenteHAI: '',
            tauxHonoraires: '',
            honoraires: '',
            honorairesAgence: '',
            nouveauPrixNetVendeur: '',
            nouveauPrixSoldeVendeur: '',
            prixNetVendeur: '',
            tauxHonorairesArrondi: '',
            resultat: '',
            isSubmitted: false,
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({prixSoldeVendeur: event.target.prixSoldeVendeur});
        this.setState({honoraires: event.target.honoraires});
        this.setState({resultat: event.target.honoraires});
    }

    handleSubmit(event) {
        console.log('CalculCas7 : handleSubmit ');
        this.setState({prixSoldeVendeur: event.target.prixSoldeVendeur.value});
        this.setState({honoraires: event.target.honoraires.value});
        this.setState({isSubmitted: true})
        event.preventDefault();

        let prixSoldeVendeur = event.target.prixSoldeVendeur.value;
        let honoraires = event.target.honoraires.value;
        let resultat = parseInt(prixSoldeVendeur) + parseInt(honoraires);

        this.setState({honoraires: honoraires});
        this.setState({resultat: resultat});
    }

    refreshPage() {
        window.location.reload();
    }

    render() {
        console.log('CalculCas7 : render ');
        let resultatContent;
        if (this.state.resultat) {
            console.log('CalculCas7 : render resultat');
            resultatContent = <div style={{border: 'thick double #289dcc',padding: 10, margin: 20}}>
                <h4>Calculs</h4>
                Résultat : <NumberFormat value={this.state.resultat} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <h4>Affichage annonce recommandé</h4>
                Prix de vente : <NumberFormat value={this.state.resultat} displayType={'text'} thousandSeparator={' '}/> € <br/>
                <br/><br/>
                <input autoFocus type="submit" value="Faire un nouveau calcul" onClick={this.refreshPage}/>
            </div>;
        }
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <label>
                        <span className="calculhonos-label">Prix solde vendeur (en €) :</span>
                        &nbsp;<input autoFocus type="text" pattern="[0-9,\.]*" name="prixSoldeVendeur" value={this.state.prixSoldeVendeur} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <label>
                        <span className="calculhonos-label">Honoraires TTC forfaitaires et fixes (en €) :</span>
                        &nbsp;<input type="text" pattern="[0-9,\.]*" name="honoraires" value={this.state.honoraires} onChange={this.handleChange} min={0}/>
                    </label>
                    <br/><br/>
                    <input type="submit" value="Calculer" />
                </form>
                {resultatContent}
            </div>
        );
    }
}

class Moulinette extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            typeHonoraires: props.typeHonoraires,
            chargesHonoraires: props.chargesHonoraires,
            prixDepart: props.prixDepart
        };

        console.log("typeHonoraires : " + this.state.typeHonoraires);
        console.log("chargesHonoraires : " + this.state.chargesHonoraires);
        console.log("prixDepart : " + this.state.prixDepart);
    }

    render() {
        console.log('Moulinette : render ');
        return (
            <div>
                {'pourcentage' === this.state.typeHonoraires && 'acquereur' === this.state.chargesHonoraires && 'prix-net-vendeur' === this.state.prixDepart
                    && <CalculCas1 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}

                {'pourcentage' === this.state.typeHonoraires && 'acquereur' === this.state.chargesHonoraires && 'prix-presentation' === this.state.prixDepart
                    && <CalculCas2 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}

                {'pourcentage' === this.state.typeHonoraires && 'vendeur' === this.state.chargesHonoraires && 'prix-solde-vendeur' === this.state.prixDepart
                    && <CalculCas3 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}

                {'pourcentage' === this.state.typeHonoraires && 'vendeur' === this.state.chargesHonoraires && 'prix-presentation' === this.state.prixDepart
                    && <CalculCas4 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}

                {'euros' === this.state.typeHonoraires && 'acquereur' === this.state.chargesHonoraires && 'prix-net-vendeur' === this.state.prixDepart
                    && <CalculCas5 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}

                {'euros' === this.state.typeHonoraires && 'acquereur' === this.state.chargesHonoraires && 'prix-presentation' === this.state.prixDepart
                    && <CalculCas6 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}

                {'euros' === this.state.typeHonoraires && 'vendeur' === this.state.chargesHonoraires && 'prix-solde-vendeur' === this.state.prixDepart
                    && <CalculCas7 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}

                {'euros' === this.state.typeHonoraires && 'vendeur' === this.state.chargesHonoraires && 'prix-presentation' === this.state.prixDepart
                    && <CalculCas7 chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}
            </div>
        );
    }
}

class PrixDepartAcquereur extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: 'coconut', isSubmitted: false, typeHonoraires: props.typeHonoraires, chargesHonoraires: props.chargesHonoraires};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        console.log('PrixDepartAcquereur : handleChange ');
        this.setState({isSubmitted: false})
        this.setState({value: ''});
        if (event.target.value) {
            this.setState({value: event.target.value});
            this.setState({isSubmitted: true})
        }
    }

    render() {
        let r
        return (
            <div>
                <form>
                    <label>
                        <span className="calculhonos-label">Prix du départ :</span>
                        &nbsp;<select autoFocus value={this.state.value} onChange={this.handleChange}>
                            <option value="">Sélectionner un prix</option>
                            <option value="prix-net-vendeur">Je démarre du prix net vendeur</option>
                            <option value="prix-presentation">Je démarre du prix de présentation grand public</option>
                        </select>
                    </label>
                </form>
                <br/>
                {this.state.isSubmitted && <Moulinette chargesHonoraires={this.state.chargesHonoraires} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value}/>}
            </div>
        );
    }
}

class PrixDepartVendeur extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: 'coconut', isSubmitted: false, typeHonoraires: props.typeHonoraires, chargesHonoraires: props.chargesHonoraires};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        console.log('PrixDepartVendeur : handleChange ');
        this.setState({isSubmitted: false})
        this.setState({value: ''});
        if (event.target.value) {
            this.setState({value: event.target.value});
            this.setState({isSubmitted: true})
        }
    }

    render() {
        return (
            <div>
                <form>
                    <label>
                        <span className="calculhonos-label">Prix du départ :</span>
                        &nbsp;<select autoFocus value={this.state.value} onChange={this.handleChange}>
                            <option value="">Sélectionner un prix</option>
                            <option value="prix-solde-vendeur">Je démarre du prix solde vendeur souhaité</option>
                            <option value="prix-presentation">Je démarre du prix de présentation grand public</option>
                        </select>
                    </label>
                </form>
                <br/>
                {this.state.isSubmitted && <Moulinette chargesHonoraires={this.state.chargesHonoraires} typeHonoraires={this.state.typeHonoraires} prixDepart={this.state.value} key={new Date().getTime()}/>}
            </div>
        );
    }
}

class ChargesHonoraires extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: null, isSubmitted: false, typeHonoraires: props.typeHonoraires};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        console.log('ChargesHonoraires : handleChange ');
        this.setState({value: event.target.value});
        this.setState({isSubmitted: true})
    }

    render() {
        return (
            <div>
                <form>
                    <label>
                        <span className="calculhonos-label">Charge des honoraires :</span>
                        &nbsp;<select autoFocus value={this.state.value} onChange={this.handleChange}>
                            <option value="">Sélectionner un ChargesHonoraires</option>
                            <option value="acquereur">Honoraires TTC à la charge de l'acquéreur</option>
                            <option value="vendeur">Honoraires TTC à la charge du vendeur</option>
                        </select>
                    </label>
                </form>
                <br/>
                {this.state.isSubmitted && 'acquereur' === this.state.value && <PrixDepartAcquereur chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} key={new Date().getTime()}/>}
                {this.state.isSubmitted && 'vendeur' === this.state.value && <PrixDepartVendeur chargesHonoraires={this.state.value} typeHonoraires={this.state.typeHonoraires} key={new Date().getTime()}/>}
            </div>
        );
    }
}

class FormInit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: 'coconut', isSubmitted: false};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({isSubmitted: false})
        if (this.state.value !== event.target.value) {
            this.setState({value: event.target.value});
            this.setState({isSubmitted: true})
        }
    }

    render() {
        console.log("FormInit render() method");
        return (
            <div>
                <form>
                    <label>
                        <span className="calculhonos-label">Type d'honoraires :</span>
                        &nbsp;<select value={this.state.value} onChange={this.handleChange}>
                            <option value="">Sélectionner un type</option>
                            <option value="pourcentage">Pourcentage %</option>
                            <option value="euros">Euros €</option>
                        </select>
                    </label>
                </form>
                <br/>
                {this.state.isSubmitted && <ChargesHonoraires typeHonoraires={this.state.value} key={new Date().getTime()}/>}
            </div>
        );
    }
}

const App = () => {
    return (
        <div>
            <FormInit />
        </div>
    );
};
export default App;
